module.exports = __webpack_public_path__ + "img/poster1.a5150fce.png";